import Vue from 'vue';
import Vuex from 'vuex';
import
{
    // globals, offer, ticket, sport, lotto, vhorse,
    globals, offer, sport, lotto, vhorse,
}
// from '../../../flex-lib-vue-common';
from '@om-retail/vue-common';
import service from './modules/service';
import props from './modules/props';
import favourites from './modules/favourites';
import player from './modules/player';
import outright from './modules/outright';
import betslip from './modules/betslip';
import ticket from './modules/ticket';

Vue.use(Vuex);

// the root, initial state object
const store = new Vuex.Store(
    {
        modules:
        {
            globals,
            service,
            ticket,
            offer,
            sport,
            lotto,
            vhorse,
            props,
            favourites,
            player,
            outright,
            betslip,
        },
    },
);

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
export default store;
